export type TabKey = "ov" | "fl" | "se" | "us";

const TABS: { key: TabKey; label: string; icon: string }[] = [
  { key: "ov", label: "OVERVIEW", icon: "ti-layout-dashboard" },
  { key: "fl", label: "FLEET", icon: "ti-device-remote" },
  { key: "se", label: "SESSIONS", icon: "ti-list-details" },
  { key: "us", label: "USERS", icon: "ti-users" },
];

export function TabNav({
  active,
  onChange,
}: {
  active: TabKey;
  onChange: (k: TabKey) => void;
}) {
  return (
    <div className="nt">
      {TABS.map((t) => (
        <button
          key={t.key}
          className={"nb" + (active === t.key ? " ac" : "")}
          onClick={() => onChange(t.key)}
        >
          <i className={"ti " + t.icon} aria-hidden="true" />
          {t.label}
        </button>
      ))}
    </div>
  );
}
